import React from 'react'
import { CardTemplate } from '../../templates/CardTemplate'
import { LoginForm } from '../../organisms/form/LoginForm'
import { useLoginPage } from './hook';

export const LoginPage = () => {

  const { handleLogin, isLoading } = useLoginPage();
  return (
    <CardTemplate title={"Log In"}>
      <LoginForm handleSubmit={handleLogin} isLoading={isLoading} />
    </CardTemplate>
  )
}
